import React, { useState } from 'react'
import { CardComponentProps } from 'nextstepjs'
import { X } from 'lucide-react'
import { Button } from 'src/component/ui/button'
import { CloseAppTourDialog } from './close-app-tour-dialog'

export const AppTourCard = ({
  step,
  currentStep,
  totalSteps,
  nextStep,
  skipTour,
  arrow,
}: CardComponentProps): React.ReactElement => {
  const [isCloseDialogOpen, setIsCloseDialogOpen] = useState(false)
  const [pendingAction, setPendingAction] = useState<'skip' | 'complete' | null>(null)

  const handleConfirmClose = (): void => {
    setIsCloseDialogOpen(false)
    if (pendingAction === 'complete') nextStep?.()
    else skipTour?.()
    setPendingAction(null)
  }

  const handleCancelClose = (): void => {
    setIsCloseDialogOpen(false)
    setPendingAction(null)
  }

  const isLastStep = currentStep + 1 === totalSteps

  return (
    <>
      <span className="text-primary">{arrow}</span>
      <div className="bg-primary rounded-lg p-1.5 w-64 shadow-xl">
        <div className="flex items-start justify-between mb-2">
          <div className="font-roboto-condensed text-primary-gray text-xs tracking-wide leading-relaxed mr-2 pl-1.5 pt-1.5">
            {step.content}
          </div>
          <button
            type="button"
            onClick={() => {
              setPendingAction('skip')
              setIsCloseDialogOpen(true)
            }}
            className="text-primary-gray hover:text-ivory transition-colors shrink-0"
            aria-label="Close tour"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="flex items-center justify-between pb-1.5 px-1.5">
          <span className="font-roboto-condensed text-primary-gray text-xs tracking-wider">
            {currentStep + 1}/{totalSteps}
          </span>
          <Button
            size="sm"
            className="text-sm bg-mist"
            onClick={
              isLastStep
                ? () => {
                    setPendingAction('complete')
                    setIsCloseDialogOpen(true)
                  }
                : nextStep
            }
          >
            {isLastStep ? 'Got it' : 'Next'}
          </Button>
        </div>
      </div>

      <CloseAppTourDialog isOpen={isCloseDialogOpen} onConfirm={handleConfirmClose} onCancel={handleCancelClose} />
    </>
  )
}
